export const buildShareTitle = (certificate, org, t) => {
    const isRequiredValuesForTitleMissing = certificate.title === '' || certificate.institution === '';

    const titleKey = isRequiredValuesForTitleMissing
        ? 'certificate.share.linkedin.post.title_default'
        : 'certificate.share.linkedin.post.title';
    return t(titleKey, {
        title: certificate.title,
        institution: certificate.institution,
        organizationName:
            certificate.institution && certificate.institution !== '' ? certificate.institution : org?.name,
        interpolation: { escapeValue: false },
    });
};

export const buildLinkedinShareComment = (certificate, org, t) => {
    const onlyTitle = certificate.title !== '';
    const onlyInstitution = certificate.institution !== '';
    const completed = onlyTitle && onlyInstitution;

    const titleKey = completed
        ? 'certificate.share.linkedin.post.org_and_title'
        : onlyTitle
          ? 'certificate.share.linkedin.post.no_org'
          : onlyInstitution
            ? 'certificate.share.linkedin.post.no_title'
            : 'certificate.share.linkedin.post.no_title_no_org';
    return `${t(titleKey, {
        title: certificate.title,
        institution: certificate.institution,
        organizationName: org?.name,
        interpolation: { escapeValue: false },
    })} \n ${t('certificate.share.linkedin.post.share_tags', { orgTag: org ? `#${org.name.replace(/\s+/g, '')}` : '' })}`;
};
